var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaitingIcon = function SvgWaitingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "waiting_icon_svg__a",
    width: 13,
    height: 19,
    x: 3,
    y: -0.5,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3-.5h13v19H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.75 6.898A4.5 4.5 0 0 0 14 3V1.5H5V3c0 1.666.905 3.12 2.25 3.898v.02a2.25 2.25 0 0 1 0 4.164v.02A4.5 4.5 0 0 0 5 15v1.5h9V15c0-1.665-.905-3.12-2.25-3.898v-.02a2.25 2.25 0 0 1 0-4.164z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "M11.75 6.898 11 5.6a1.5 1.5 0 0 0-.749 1.298zM14 1.5h1.5A1.5 1.5 0 0 0 14 0zm-9 0V0a1.5 1.5 0 0 0-1.5 1.5zm2.25 5.398h1.5A1.5 1.5 0 0 0 8.001 5.6zm0 .02h-1.5a1.5 1.5 0 0 0 .93 1.388zm0 4.164-.57-1.388a1.5 1.5 0 0 0-.93 1.388zm0 .02.751 1.298a1.5 1.5 0 0 0 .75-1.298zM5 16.5H3.5A1.5 1.5 0 0 0 5 18zm9 0V18a1.5 1.5 0 0 0 1.5-1.5zm-2.25-5.398h-1.5A1.5 1.5 0 0 0 11 12.4zm0-.02h1.5a1.5 1.5 0 0 0-.93-1.388zm0-4.164.57 1.388a1.5 1.5 0 0 0 .93-1.388zM12.5 3c0 1.109-.6 2.079-1.501 2.6l1.502 2.596A6 6 0 0 0 15.5 3zm0-1.5V3h3V1.5zM5 3h9V0H5zm1.5 0V1.5h-3V3zm1.501 2.6a3 3 0 0 1-1.5-2.6h-3a6 6 0 0 0 2.998 5.196zm.75 1.318v-.02h-3v.02zM10.144 9A3.75 3.75 0 0 0 7.82 5.531L6.679 8.306A.75.75 0 0 1 7.145 9zM7.82 12.469A3.75 3.75 0 0 0 10.145 9h-3a.75.75 0 0 1-.466.694zm.93-1.367v-.02h-3v.02zM6.5 15c0-1.109.6-2.079 1.501-2.6L6.5 9.803A6 6 0 0 0 3.5 15zm0 1.5V15h-3v1.5zM14 15H5v3h9zm-1.5 0v1.5h3V15zm-1.501-2.6c.9.521 1.5 1.492 1.5 2.6h3a6 6 0 0 0-2.998-5.196zm-.749-1.318v.02h3v-.02zM8.856 9a3.75 3.75 0 0 0 2.324 3.469l1.14-2.775A.75.75 0 0 1 11.857 9zm2.324-3.469A3.75 3.75 0 0 0 8.856 9h3c0-.31.19-.581.465-.694zm-.93 1.367v.02h3v-.02z",
    mask: "url(#waiting_icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.5 15h-6l3-3z"
  })));
};
export default SvgWaitingIcon;